// Always use relative path /api for both development and production
// This works because Vercel routes /api/* to the serverless backend
const API_BASE_URL = '/api';

// Debug log (remove after verification)
console.log('API Configuration:', {
  API_BASE_URL
});

/**
 * Create payment order with Razorpay
 */
export const createPaymentOrder = async (formData, couponCode = null, priorityDelivery = false) => {
  try {
    const response = await fetch(`${API_BASE_URL}/payment/create-order`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ formData, couponCode, priorityDelivery })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to create payment order');
    }

    return data;
  } catch (error) {
    console.error('Create order error:', error);
    throw error;
  }
};

/**
 * Verify payment with backend
 */
export const verifyPayment = async (paymentResponse, formData, couponCode = null, priorityDelivery = false) => {
  try {
    const response = await fetch(`${API_BASE_URL}/payment/verify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        razorpay_order_id: paymentResponse.razorpay_order_id,
        razorpay_payment_id: paymentResponse.razorpay_payment_id,
        razorpay_signature: paymentResponse.razorpay_signature,
        formData,
        couponCode,
        priorityDelivery
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Payment verification failed');
    }

    return data;
  } catch (error) {
    console.error('Verify payment error:', error);
    throw error;
  }
};

/**
 * Initialize Razorpay checkout and open payment modal
 */
export const initiateRazorpayPayment = (orderData, formData) => {
  return new Promise((resolve, reject) => {
    if (!window.Razorpay) {
      reject(new Error('Razorpay SDK not loaded'));
      return;
    }

    const options = {
      key: orderData.keyId,
      amount: orderData.amount,
      currency: orderData.currency,
      name: 'Projekto',
      description: 'Project Submission Fee',
      order_id: orderData.orderId,
      prefill: {
        name: formData.teamName,
        email: formData.email,
        contact: formData.phone || ''
      },
      theme: {
        color: '#121212'
      },
      handler: function (response) {
        resolve(response);
      },
      modal: {
        ondismiss: function () {
          reject(new Error('Payment cancelled by user'));
        }
      }
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();
  });
};
